var map = {
	"./caravaggio/info/1.png": "1bf3",
	"./caravaggio/info/2.png": "5024",
	"./caravaggio/info/3.png": "be99",
	"./caravaggio/info/4.png": "85b4",
	"./caravaggio/info/Caravaggio_story_end.png": "5b86",
	"./caravaggio/info/intro.png": "7ea6",
	"./caravaggio/success/10.png": "e307",
	"./caravaggio/success/11.png": "5d2d",
	"./caravaggio/success/12.png": "f451",
	"./caravaggio/success/13.png": "bfab",
	"./caravaggio/success/14.png": "726f",
	"./caravaggio/title.png": "b37c",
	"./layout/Risorsa 10.png": "8860",
	"./layout/Risorsa 8.png": "d711",
	"./layout/background-1.png": "e923",
	"./layout/caravaggio-title.png": "e1da",
	"./layout/caravaggio.png": "e81f",
	"./layout/completed-music.png": "ba3d",
	"./layout/completed-woman.png": "6a52",
	"./layout/completed.png": "2445",
	"./layout/credit.png": "4cd1",
	"./layout/credits.png": "0a71",
	"./layout/list-item.png": "56b5",
	"./layout/logo.png": "f524",
	"./layout/marchi.png": "7104",
	"./layout/modal_unsuccess.png": "7809",
	"./layout/modal_unsuccess@0.65x-8.png": "ddc2",
	"./layout/music.png": "62ba",
	"./layout/next.png": "beb7",
	"./layout/partner.png": "f928",
	"./layout/play.png": "3569",
	"./layout/project.png": "2ed8",
	"./layout/reset.png": "5673",
	"./layout/social_credit.png": "c31d",
	"./layout/stories.png": "f6b8",
	"./layout/title.png": "29e3",
	"./layout/woman.png": "0ccf",
	"./music/info/1.png": "5b05",
	"./music/info/2.png": "41c3",
	"./music/info/3.png": "8055",
	"./music/info/Music_story_end.png": "ee42",
	"./music/info/Webp.net-resizeimage.png": "eefe",
	"./music/info/intro-1.png": "ee5f",
	"./music/info/intro-2.png": "47c2",
	"./music/success/30.png": "c58b",
	"./music/success/31.png": "7f88",
	"./music/success/32.png": "4b5c",
	"./music/success/33.png": "cec7",
	"./music/success/34.png": "8155",
	"./music/title.png": "019a",
	"./woman/game/20.png": "301b",
	"./woman/game/21-1.png": "b49f",
	"./woman/game/21-2.png": "d91c",
	"./woman/game/21-3.png": "81da",
	"./woman/game/22-1.png": "29a5",
	"./woman/game/22-2.png": "198e",
	"./woman/game/22-3.png": "8d49",
	"./woman/game/23-1.png": "6fe7",
	"./woman/game/23-2.png": "f8d2",
	"./woman/game/23-3.png": "d510",
	"./woman/game/24.png": "e359",
	"./woman/info/1.png": "028b",
	"./woman/info/2.png": "8439",
	"./woman/info/3.png": "32a2",
	"./woman/info/4.png": "dd20",
	"./woman/info/Woman_story_end.png": "9358",
	"./woman/info/intro.png": "4a23",
	"./woman/success/20.png": "7916",
	"./woman/success/21.png": "92d4",
	"./woman/success/22.png": "3f04",
	"./woman/success/23.png": "9900",
	"./woman/success/24.png": "cfca",
	"./woman/title.png": "9803"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";